import React from 'react';
import IconName from "types/IconName";
import Icon from "../../../Icon";

type TokenProps = {
    icon?: IconName | null
    children: string
    onRemove?: () => any
}

function ComboboxToken({icon, children, onRemove}: TokenProps) {
    return (
        <span className="my-1.5 mx-1 inline-flex gap-1 items-center rounded-md bg-brand/20 py-1 pl-2 pr-1.5 text-xs font-medium text-brand pointer-events-none">
            {!!icon && <Icon name={icon} className='h-4 w-4 mr-1 flex-shrink-0' />}

            {/* Text content */}
            {children}

            {/* Removal button */}
            {!!onRemove &&
                <button
                    type="button"
                    className="ml-0.5 h-4 w-4 inline-flex items-center justify-center rounded-full text-brand hover:bg-brand hover:text-white focus:bg-brand focus:text-white focus:outline-none pointer-events-auto flex-wrap"
                    onClick={onRemove}
                >
                    {/* Screen-reader label */}
                    <span className="sr-only">Remove {children}</span>

                    {/* Cross */}
                    <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                        <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7"/>
                    </svg>
                </button>
            }
      </span>
    );
}

export default ComboboxToken;